import React from 'react'
import { useTranslation } from '@mc/i18n'
import { LAST_LOGIN_REMINDER_NAMESPACE } from '../i18n'

interface LastLoginBadgeProps {
  className?: string
}

export const LastLoginBadge: React.FC<LastLoginBadgeProps> = ({
  className = '',
}) => {
  const { t } = useTranslation(LAST_LOGIN_REMINDER_NAMESPACE)

  return (
    <div
      className={`${className}`}
      style={{
        backgroundColor: '#b7e9cc',
        color: '#134529',
        fontSize: '10px',
        letterSpacing: '0.2px',
        lineHeight: '1.45',
        padding: '2px 8px',
        borderRadius: '12px',
        whiteSpace: 'nowrap',
        height: '20px',
      }}
      data-testid='last-login-badge'
    >
      {t('lastLoginBadge')}
    </div>
  )
}

interface WithLastLoginBadgeProps {
  isLastLoginMethod: boolean
  children: React.ReactNode
}

export const WithLastLoginBadge: React.FC<WithLastLoginBadgeProps> = ({
  isLastLoginMethod,
  children,
}) => (
  <div className='position-relative'>
    {children}
    {isLastLoginMethod && (
      <div
        className='position-absolute'
        style={{
          top: '-10px',
          right: '6px',
          zIndex: 10,
          pointerEvents: 'none',
        }}
      >
        <LastLoginBadge />
      </div>
    )}
  </div>
)
